import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './common/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CreateCompanyService } from './common/services/create-company.service';
import { FormsModule } from '@angular/forms';
import { NgSwitch, NgSwitchDefault, NgSwitchCase, NgIf } from '@angular/common';

@Component({
  selector: 'app-create-company',
  templateUrl: './create-company.component.html',
  standalone: true,
  imports: [NgSwitch, NgSwitchDefault, FormsModule, NgSwitchCase, NgIf]
})
export class CreateCompanyComponent implements OnInit {
  public errorMsg: string;
  public focus: string;
  public validationKey: string;
  public setNewPasswordText: string;
  public setRetypeNewPasswordText: string;
  public emailAddress: string;
  public companyName: string;
  public firstName: string;
  public lastName: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private createCompanyService: CreateCompanyService,
    private toastService: ToastrService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.validationKey = params['validation-key'];
      this.emailAddress = params['email'];
    });

    this.createCompanyService.myCompany.subscribe((e) => {
      if (e) {
        this.companyName = e.name;
      }
    });

    this.createCompanyService.myInfo.subscribe((e) => {
      if (e) {
        this.firstName = e.first_name;
        this.lastName = e.last_name;
      }
    });
  }

  setNewPassword() {
    this.errorMsg = '';

    if (this.setNewPasswordText) {
      this.authService.setNewPassword(this.setNewPasswordText, this.validationKey).subscribe({
        next: (u) => {
          this.toastService.success('New password has been set', 'New Password');
          this.focus = 'changecompanyinfo';
        },
        error: (err) => {
          this.toastService.error('Unable to set new password', 'New Password Error');
        }
      });
    } else {
      this.toastService.error('Unable to set new password', 'New Password Error');
    }
  }

  saveCompanyInfo() {
    this.errorMsg = '';
    if (!(this.firstName && this.lastName && this.companyName)) {
      this.errorMsg = 'All the fields are required.';
      return;
    }
    if (this.firstName && this.lastName && this.companyName) {
      this.createCompanyService
        .updateUserName({
          first_name: this.firstName,
          last_name: this.lastName
        })
        .then((r) => {
          this.toastService.success('Saved first name and last name', 'Company Info');
          this.createCompanyService
            .updateUserCompanyName(this.companyName)
            .then((s) => {
              this.toastService.success('Saved company info', 'Company Info');
              this.router.navigate(['/']);
            })
            .catch((e) => this.toastService.error('Unable to save company name', 'Company Info'));
        })
        .catch((e) => this.toastService.error('Unable to save your name', 'Company Info'));
    }
  }
}
